import React, { useEffect } from "react";
import Button from "../../components/button";
import Loader from "../../components/loader";
import TextField from "../../components/textField/textField";

import PopUp, { openPopUp } from "../../components/popUp";
import { useAppContext } from "../../context/appContext";
import { formatPrice } from "../../utils/priceUtils";
import "./payOutPopUp.css";
import PayOutSuccessPopUp from "./payOutSuccessPopUp";

export default function PayOutPopUp() {

    const {payoutController, sessionId} = useAppContext();

    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string | undefined>(undefined);

    const [balance, setBalance] = React.useState<number>(-1);
    const [iban, setIban] = React.useState<string>("");
    const [bic, setBic] = React.useState<string>("");
    const [recipient, setRecipient] = React.useState<string>("");

    async function fetchMostRecentPayout() {
        await payoutController.getMostRecentPayOut(sessionId).then(response => {
            const data = response.data;
            setBalance(data.balance);
            if(data.lastPayout) {
                setIban(data.lastPayout.iban);
                setBic(data.lastPayout.bic);
                setRecipient(data.lastPayout.recipient);
            }else {
                setRecipient(data.name);
            }
        });
    }

    useEffect(() => {
        fetchMostRecentPayout();
    }, []);

    if(balance == -1) return <PopUp className="big payout-popup" title="Pay Out Revenue"><Loader/></PopUp>;


    return <PopUp className="big payout-popup" title="Pay Out Revenue">
            <h2>{formatPrice(balance)} €</h2>
            <p className="info">Processing your request may take time. You will receive your money in less then 7 days.</p>
            <TextField label="IBAN" value={iban} onChange={setIban} placeholder="Enter your IBAN" />
            <TextField label="BIC" value={bic} onChange={setBic} placeholder="Enter your BIC" />
            <TextField label="Recipient" value={recipient} onChange={setRecipient} placeholder="Enter the recipient's name" />
            <p className="error">{error}</p>
            <Button loading={loading} onClick={async function() {
                setLoading(true);
                await payoutController.sendPayOut(sessionId, {
                    iban: iban,
                    bic: bic,
                    recipient: recipient
                }).then( response => {
                    fetchMostRecentPayout();
                    openPopUp(<PayOutSuccessPopUp/>);
                }).catch( error => {
                    setError(error.response.data.message);
                });
                setLoading(false);
            }}>Send</Button>
    </PopUp>

}